module.exports = __webpack_public_path__ + "img/Jump Casting87.85647e5e.jpg";